import {
  Component,
  input,
  computed,
  ChangeDetectionStrategy,
  signal,
  effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'soft-coverage-bar',
  imports: [CommonModule],
  templateUrl: './coverage-bar.component.html',
  styleUrls: ['./coverage-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageBarComponent {
  readonly coverage = input<number>(0);
  readonly color = input<string>('#3b82f6');
  readonly width = input<string>('100%');
  readonly height = input<string>('1rem');
  readonly showPercentage = input<boolean>(false);
  readonly borderColor = input<string>('#d1d5db');
  readonly animationDelay = input<number>(200);
  readonly animationDuration = input<number>(1000);

  private readonly animatedValue = signal<number>(0);
  private readonly isAnimating = signal<boolean>(false);

  readonly containerClasses = input<string>('');
  readonly barClasses = input<string>('');
  readonly textClasses = input<string>('');

  readonly animatedWidth = computed(() => {
    const val = Math.max(0, Math.min(100, this.animatedValue()));
    return `${val}%`;
  });

  readonly transitionStyle = computed(() => {
    return this.isAnimating() ? `width ${this.animationDuration()}ms ease-out` : 'none';
  });

  constructor() {
    effect(() => {
      const targetValue = this.coverage();
      const delay = this.animationDelay();
      this.animatedValue.set(0);
      this.isAnimating.set(false);

      setTimeout(() => {
        this.isAnimating.set(true);
        this.animatedValue.set(targetValue);
      }, delay);
    });
  }
}
